var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"admin__download"},[_c('button',{staticClass:"admin__download__button btn",on:{"click":function($event){return _vm.download()}}},[_vm._v("\n\t\t"+_vm._s(_vm.status)+"\n\t\t"),(_vm.downloadStarted)?_c('Spinner',{attrs:{"size":20,"color":_vm.color}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }